import anime from 'animejs';

export function lineInit(el) {
  const elToTween = el instanceof HTMLElement ? el : el.node;
  const tween = anime.set(elToTween, { scaleX: 0, transformOrigin: '0% 0%' });

  return tween;
}

export function lineAnim(el, delay = 500) {
  const elToTween = el instanceof HTMLElement ? el : el.node;
  const tween = anime({
    targets: elToTween,
    scaleX: 1,
    easing: 'spring(4, 100, 30, 2.5)',
    delay,
  });

  return tween;
}
